import React, { useState, useEffect } from 'react';
import './App.css';
import Navigation from './components/Navigation';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Chat from './components/Chat';
import Admin from './components/Admin';
import DataSourceConfig from './components/DataSourceConfig';
import PromptConfig from './components/PromptConfig';
import BatchPromptConfig from './components/BatchPromptConfig';
import BatchHistory from './components/BatchHistory';
import { useMsal } from '@azure/msal-react';
import { Box } from '@mui/material';

function App() {
  const { instance, accounts, inProgress } = useMsal();
  const [drawerOpen, setDrawerOpen] = useState(true);

  useEffect(() => {
    // Only redirect if MSAL is not busy and there are no accounts
    if (inProgress === "none" && accounts.length === 0) {
      instance.loginRedirect();
    }
  }, [instance, inProgress, accounts]);

  if (accounts.length === 0) {
    // Optionally, show a loading spinner here
    return null;
  }

  return (
    <BrowserRouter>
      <div className="App">
        <Navigation drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            padding: 3,
            marginTop: '64px',
            marginLeft: drawerOpen ? '240px' : '56px',
            transition: 'margin-left 0.3s',
          }}
        >
          <Routes>
            <Route path="/" element={<Navigate to="/chat" replace />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/batch-history" element={<BatchHistory />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/data-source" element={<DataSourceConfig />} />
            <Route path="/admin/prompt" element={<PromptConfig />} />
            <Route path="/admin/batch-prompt" element={<BatchPromptConfig />} />
          </Routes>
        </Box>
      </div>
    </BrowserRouter>
  );
}

export default App;
